import { BaseItem } from 'components/dropdowns/SearchDropdown/itemRenderers/BaseItem'
import React, { ButtonHTMLAttributes } from 'react'
import { useNavigate } from 'react-router'
import { ReportTemplate } from 'silta-ai-backend'
import styled from 'styled-components'
import { route } from 'utils/routes'

const Content = styled.div`
    min-width: 0;
`

interface ReportTemplateItemProps
    extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
    value: ReportTemplate
}

export function ReportTemplateItem({
    value,
    onClick: onClickProp,
    ...rest
}: ReportTemplateItemProps) {
    const navigate = useNavigate()

    return (
        <BaseItem
            {...rest}
            onClick={(e) => {
                onClickProp?.(e)

                navigate(route('reportTemplate', value.id))
            }}
        >
            <Content>{value.name}</Content>
        </BaseItem>
    )
}
